




















import Vue from 'vue';

import { BFormCheckbox, VBTooltip } from 'bootstrap-vue';

export default Vue.extend({
  name: 'AdvanceSwitch',
  components: {
    BFormCheckbox,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      requiered: true,
    },
  },
  computed: {
    switchValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {},
});
